import { FormControlLabel, FormControlLabelProps, Switch } from '@mui/material'
import { ReactNode, useCallback } from 'react'
import { useController, UseControllerProps } from 'react-hook-form'

type SwitchProps = {
    label?: ReactNode
    disabled?: boolean
    isOppositeValue?: boolean
    color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
    onChangeCallback?: (value: boolean) => void
    overrideOnChange?: (val: boolean, onchange: (val: boolean) => void) => void
    width?: string | number
    size?: 'small' | 'medium'
    customValue?: boolean
}
function OWSwitch<T extends object>({
    name,
    control,
    label,
    disabled = false,
    isOppositeValue = false,
    labelPlacement,
    onChangeCallback,
    color,
    overrideOnChange,
    width,
    size,
    customValue,
}: SwitchProps &
    UseControllerProps<T> &
    Pick<FormControlLabelProps, 'label' | 'labelPlacement' | 'disabled'>) {
    const { field } = useController<T>({ name, control })

    const { onChange, value = customValue ?? false, ...otherField } = field

    const updateValue = useCallback(
        (val: boolean) => {
            onChange(!isOppositeValue ? val : !val)
            if (onChangeCallback) {
                onChangeCallback(val)
            }
        },
        [isOppositeValue, onChange, onChangeCallback],
    )

    return (
        <FormControlLabel
            color={color}
            control={
                <Switch
                    color={color}
                    onChange={(e, val) => {
                        if (overrideOnChange) overrideOnChange(val, updateValue)
                        else updateValue(val)
                    }}
                    checked={!isOppositeValue ? value : !value}
                    {...otherField}
                    size={size}
                />
            }
            label={label}
            disabled={disabled}
            labelPlacement={labelPlacement}
            style={{ width: width }}
        />
    )
}

export default OWSwitch
